import { Box } from "@mui/material";

import { styled } from "@mui/material/styles";

export const StatCard = styled(Box)(({ theme }) => ({
  display: "flex",
  flexShrink: 0,
  flexDirection: "column",
  gap: theme.spacing(1.5),
  padding: theme.spacing(3),
  borderWidth: 1,
  borderStyle: "solid",
  borderColor: theme.vars.palette.borders.neutral.subtle,
  backgroundColor: theme.vars.palette.background.paper,
  borderRadius: theme.spacing(1.5),
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(2.5),
  },
})) as typeof Box;
